import { useCallback } from 'react'
import { toast } from 'react-toastify'
import capitalize from '../../../common/formatters/capitalize'

const clean  = value => value ? `'${value}'` : ''

export default ({ addItem, deleteItem, updateItem, setShowNew, entityLabel, entityName }) => {

  const onDelete = useCallback(
    (id, item) => deleteItem(id).then(() => {
      toast.success(`${capitalize(entityLabel || entityName)} ${clean(item.description)} deleted`, {
        position: toast.POSITION.TOP_RIGHT,
      })
      setShowNew(true)
    }),
    [deleteItem, entityLabel, entityName, setShowNew],
  )
  const onSave = useCallback(
    item => {
      const result = {
        ...item,
      }
      delete result.id
      return updateItem(item.id, result).then(() =>
        toast.success(`${capitalize(entityLabel || entityName)} ${clean(result.description)} updated`, {
          position: toast.POSITION.TOP_RIGHT,
        }))
    },
    [entityLabel, entityName, updateItem],
  )

  const onAdd = useCallback(
    item => {
      const result = {
        ...item,
      }
      return addItem(result).then(() => {
        toast.success(`${capitalize(entityLabel || entityName)} ${clean(result.description)} added`, {
          position: toast.POSITION.TOP_RIGHT,
        })
        setShowNew(true)
      })
    },
    [addItem, entityLabel, entityName, setShowNew],
  )
  return {
    onAdd,
    onSave,
    onDelete,
  }
}
